module.exports = __webpack_public_path__ + "static/virtual-a24d1f88b70706fa0c93bc4b2c62f479.jpg";